import { Component, OnInit, ViewChild } from '@angular/core';
import { AppSettings } from './../../app.settings';
import { IonTabs, LoadingController, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { RestService } from 'src/app/services/rest.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MeTabPage } from '../me-tab/me-tab.page';
import { EventService } from 'src/app/services/event.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  [x: string]: any;
  //tabs: IonTabs;
  @ViewChild('my_profile_tabs', { read: IonTabs, static: true }) tabRef: IonTabs;
  userProfileReq = { Uid: "" };
  userProfileResponse: any;
  userId: string;
  roleId: any;
  IsPSMLogin: boolean;
  IsAdminLogin: boolean;
  IsTSMLogin = false;
  subscription: any;

  AppTitle: string;
  ME: string;
  Team: string;
  Summary: string;
  Unauthorized: string;
  message: string;
  ok: string;


  pageHeader : string = '';



  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private restService: RestService,
    private storage: StorageService,
    private loadingController: LoadingController,
    private event: EventService,
    public alertController: AlertController
  ) {

    this.IsAdminLogin = false;
  }


  ngOnInit() {
  }

  ionViewWillEnter() {
  }

  ionViewDidEnter() {
    this.storage.get(AppSettings.SYNUID).then((res: string) => {
      //this.userProfileReq.Uid = res.replace('@syngenta.org', '').replace('@SYNGENTA.ORG','');
      this.userProfileReq.Uid = res;
      this.getUserProfileList(true);
    });

    // this.userProfileReq.Uid = 'SuIk.Jang@syngenta.com';//"kavita.korde@syngenta.com";//"Dattatray.Pise@syngenta.com";//"nupur.rao@syngenta.com"; // ""; //// "Dattatray.Pise@syngenta.com"; // "taeheoun.kim@syngenta.com;"
    // this.getUserProfileList(true);  

  }



  async getUserProfileList(loader: boolean, infiniteScroll?: any) {

    const loading = await this.loadingController.create({
      message: '로딩…'
    });
    if (loader)
      await loading.present();

    // console.log(this.orderRequest)
    this.restService.postData('GetUserProfileData', this.userProfileReq).subscribe((response) => {

      // this.userProfileResponse = response
      if (response.UserProfileData.Id != 0) {
        this.userId = response.UserProfileData.Id;
        this.roleId = response.UserProfileData.RoleID;
        this.storage.set(AppSettings.USER_INFO, response).then(() => {
          this.event.publish('user-details', response);
        })
        loading.dismiss();
        AppSettings.CALENDAR_DAYS = response.listConfigValues[0].Value;
        AppSettings.EDITABLE_BACK_DAYS = response.listConfigValues[1].Value;
      
        for (let title of response.listAppLabals) {
          switch (title.LabalName) { // if(title.LabalName === "Sales Call-KR")
            case "Sales Call-KR":
              this.AppTitle = title.LabalValue;
              break;
            case "Me":
              this.ME = title.LabalValue;
              break;
            case "Team":
              this.Team = title.LabalValue;
              break;
            case "Summary":
              this.Summary = title.LabalValue;
              break;
            case "Unauthorized":
              this.Unauthorized = title.LabalValue;
              break;
            case "You are not authorized to view this application\'s content":
              this.message = title.LabalValue;
              break;
            case "Ok":
              this.ok = title.LabalValue;
              break;
          }
        }

        if(response.UserProfileData.BusinessUnit_Name === "SPS"){
          this.pageHeader = 'Landscape'
        }else{
          this.pageHeader = 'Sales Call'
        }
       
        if(response.Configurations[0].EnableDGSaleCall){
          if (this.roleId === 1) {
            this.IsPSMLogin = true;
            this.IsAdminLogin = false;
            this.tabRef.select('me-tab');
          } else if (this.roleId === 2) {
            this.IsPSMLogin = false;
            this.IsAdminLogin = false;
            this.tabRef.select('me-tab');
          } else {
            this.IsPSMLogin = false;
            this.IsAdminLogin = true;
          }
        }


        // if (response.UserProfileData.BusinessUnit_Name === "SPSD") {

        //   this.userId = response.UserProfileData.Id;
        //   this.roleId = response.UserProfileData.RoleID;
        //   this.storage.set(AppSettings.USER_INFO, response).then(() => {
        //     this.event.publish('user-details', response);
        //   })
        //   loading.dismiss();
          
        //   this.router.navigate(['touch500'], { replaceUrl: true });
        // } else if (response.UserProfileData.BusinessUnit_Name === "CP" || response.UserProfileData.BusinessUnit_Name === "SPS") {
        //   this.userId = response.UserProfileData.Id;
        //   this.roleId = response.UserProfileData.RoleID;

        //   AppSettings.CALENDAR_DAYS = response.listConfigValues[0].Value;
        //   console.log('AppSettings.CALENDAR_DAYS : ' + AppSettings.CALENDAR_DAYS);
        //   AppSettings.EDITABLE_BACK_DAYS = response.listConfigValues[1].Value;
        //   console.log('AppSettings.EDITABLE_BACK_DAYS : ' + AppSettings.EDITABLE_BACK_DAYS);

        //   for (let title of response.listAppLabals) {
        //     switch (title.LabalName) { // if(title.LabalName === "Sales Call-KR")
        //       case "Sales Call-KR":
        //         this.AppTitle = title.LabalValue;
        //         break;
        //       case "Me":
        //         this.ME = title.LabalValue;
        //         break;
        //       case "Team":
        //         this.Team = title.LabalValue;
        //         break;
        //       case "Summary":
        //         this.Summary = title.LabalValue;
        //         break;
        //       case "Unauthorized":
        //         this.Unauthorized = title.LabalValue;
        //         break;
        //       case "You are not authorized to view this application\'s content":
        //         this.message = title.LabalValue;
        //         break;
        //       case "Ok":
        //         this.ok = title.LabalValue;
        //         break;
        //     }
        //   }

        //   if (this.roleId === 1) {
        //     this.IsPSMLogin = true;
        //     this.IsAdminLogin = false;
        //     this.tabRef.select('me-tab');
        //   } else if (this.roleId === 2) {
        //     this.IsPSMLogin = false;
        //     this.IsAdminLogin = false;
        //     this.tabRef.select('me-tab');
        //   } else {
        //     this.IsPSMLogin = false;
        //     this.IsAdminLogin = true;
        //   }
        //   this.storage.set(AppSettings.USER_INFO, response).then(() => {
        //     this.event.publish('user-details', response);
        //   })
        //   loading.dismiss();

        // }
      } else {
        this.presentApprovalAlert();
        loading.dismiss();
      }
    });
  }

  async presentApprovalAlert() {
    const alert = await this.alertController.create({
      header: '권한없음',
      message: '해당 어플리케이션 내용을 볼 수 있는 권한이 없습니다',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    await alert.present();
  }


  logout() {
    this.authService.logout();
  }

  // loadMeTabData(){
  //   console.log("Load Me Data");   
  // }

  goToLandingPage() {
    this.router.navigate(['landing']);
  }

}
